import React, {useRef, useEffect} from 'react';

import Arrow from '../icons-af/arrow';

import _ from '../../utils/_';
import useCarouselScroll from '../../hooks/use-carousel-scroll/use-carousel-scroll';
import '../carousel-scroll/carousel-scroll.scss';
import './product-carousel-vertical.scss';

const ProductCarouselVertical = ({items, alt, active, onChange = _.noop}: propTypes) => {
  const target = useRef(null);
  const instanceRef = useCarouselScroll(target, {vertical: true}, [items]);

  useEffect(() => {
    if (items.length > 0) {
      instanceRef.current.set(active);
    }
  });

  const handleClick = (i) => (e) => {
    e.preventDefault();
    if (i === active || i < 0 || i >= items.length) {
      return;
    }
    instanceRef.current.set(i);
    onChange(i);
  };

  return (
    <div
      ref={target}
      className="carousel-scroll carousel-scroll-vertical product-carousel-vertical"
    >
      <a
        onClick={handleClick(active - 1)}
        className={'carousel-scroll-control-prev' + (active === 0 ? ' disabled' : '')}
        href="#"
        role="button"
      >
        <span className="carousel-scroll-control-prev-icon" aria-hidden="true">
          <Arrow height="100%" width="24px" rotate={270} />
        </span>
        <span className="sr-only">{'Previous'}</span>
      </a>
      <div className="carousel-scroll-outer">
        <div className="carousel-scroll-inner">
          {items.map((x, i) => (
            <div key={i} className={'carousel-scroll-item' + (active === i ? ' active' : '')}>
              <figure
                onClick={handleClick(i)}
                style={{
                  height: '64px',
                  margin: 0,
                  position: 'relative',
                }}
              >
                <img
                  loading="lazy"
                  src={x.thumbnail_url ?? x.retina_url}
                  alt={alt}
                  style={{position: 'absolute', top: 0, left: 0}}
                  width="64px"
                  height="64px"
                />
              </figure>
            </div>
          ))}
        </div>
      </div>
      <a
        onClick={handleClick(active + 1)}
        className={
          'carousel-scroll-control-next' + (active === items.length - 1 ? ' disabled' : '')
        }
        href="#"
        role="button"
      >
        <span className="carousel-scroll-control-next-icon" aria-hidden="true">
          <Arrow height="100%" width="24px" rotate={90} />
        </span>
        <span className="sr-only">{'Next'}</span>
      </a>
    </div>
  );
};

interface propTypes {
  items: any[];
  alt: string;
  active: number;
  onChange?: (n) => any;
}

export default ProductCarouselVertical;
